import {
  LoginRequest,
  LoginResponse,
  RequestPasswordResetRequest,
  SetPasswordRequest,
  VerifyEmailRequest,
} from "@/models/user.model";
import http from "@/services/http";

export async function login(request: LoginRequest): Promise<LoginResponse> {
  return http.post<LoginResponse>("/auth/login", {
    emailOrUsername: request.emailOrUsername.toLowerCase(),
    password: request.password,
  });
}

export async function setPassword(request: SetPasswordRequest): Promise<string> {
  return http.post<string>("/auth/set-password", request);
}

export async function requestPasswordReset(
  request: RequestPasswordResetRequest
): Promise<string> {
  return http.post<string>("/auth/forgot-password", request);
}

export async function verifyEmail(request: VerifyEmailRequest): Promise<void> {
  return http.post<void>("/auth/verify-email", request);
}
